<template>
  <div class="mit-admin-equipment-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>ADMIN - Equipment Management</v-card-title>
            <v-card-subtitle class="caption">TIG Equipment Management</v-card-subtitle>
            <v-divider></v-divider>
            <v-toolbar color="primary" dense>
              <v-btn color="white" :text="menuIndex != 0" @click="menuChange(0)">Categories</v-btn>
              <v-btn color="white" :text="menuIndex != 1" @click="menuChange(1)">Equipment</v-btn>
              <v-btn color="white" :text="menuIndex != 2" @click="menuChange(2)">Reservations</v-btn>
              <v-btn color="white" :text="menuIndex != 3" @click="menuChange(3)">Give Aways</v-btn>
              <v-btn color="white" :text="menuIndex != 4" @click="menuChange(4)">Dashboard</v-btn>
            </v-toolbar>
            <v-card-text>
              <div v-if="menuIndex == 0">
                <h2>Equipment Categories</h2>
                <p>Create and edit equipment categories</p>
                <MitDataTable :headersModel="categoryDataHeaders" :dataModel="categoryData" :pagingModel="categoryPaging" createButtonText="Add Category" v-on:mit-data-table-create="categoryCreate" v-on:mit-data-table-edit="categoryEdit" v-on:mit-data-table-refresh="categoryRefresh"/>
              </div>
              <div v-if="menuIndex == 1">
                <h2>Equipment</h2>
                <p>Create and edit equipment categories</p>
                <MitDataTable :headersModel="equipmentDataHeaders" :dataModel="equipmentData" :pagingModel="equipmentPaging" createButtonText="Add Equipment" v-on:mit-data-table-create="equipmentCreate" v-on:mit-data-table-edit="equipmentEdit" v-on:mit-data-table-refresh="equipmentRefresh"/>
              </div>
              <div v-if="menuIndex == 2">
                <h2>Reservations</h2>
                <p>Manage reservations</p>
                <MitDataTable :headersModel="reservationDataHeaders" :dataModel="reservationData" :pagingModel="reservationPaging" createButtonText="New Reservation" v-on:mit-data-table-create="reservationCreate" v-on:mit-data-table-edit="reservationEdit" v-on:mit-data-table-refresh="reservationRefresh"/>
              </div>
              <div v-if="menuIndex == 3">
                <h2>Give Aways</h2>
                <p>Manage give aways</p>
                <MitDataTable :headersModel="giveDataHeaders" :dataModel="giveData" :pagingModel="givePaging" createButtonText="New Give Away" v-on:mit-data-table-create="giveCreate" v-on:mit-data-table-edit="giveEdit" v-on:mit-data-table-refresh="giveRefresh"/>
              </div>
              <div v-if="menuIndex == 4">
                <h2>Dashboard</h2>
                <p>Stats and charts on usage.</p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import MitEquipmentApiService from '../../services/MitEquipmentApiService.js';
  import MitDataTable from '../../components/MitDataTable.vue';

  export default {
    name: 'MitAdinEquipmentPage',
    components: {
      MitDataTable
    },
    data: function() {
      return {
        menuIndex:0,
        categoryDataHeaders:{
          items:[
                      {text: 'Name',align: 'start',sortable: true,value: 'name',},
                      { text: 'Last Updated', value: 'last_updated_localfromnow' },
                      { text: "", value: "editButton" } //Add edit button
                ]
        },
        categoryData:{
          items:[]
        },
        categoryPaging:{
          page:1,
          pageSize:20,
          totalItems:0
        },
        equipmentDataHeaders:{
          items:[
                      {text: 'Name',align: 'start',sortable: false, value: 'name'},
                      { text: 'Description',sortable: false, value: 'description' },
                      { text: 'Category',sortable: false, value: 'category' },
                      { text: 'Quantity',sortable: false, value: 'quantity' },
                      //{ text: 'Last Updated',sortable: false, value: 'last_updated_localfromnow' },
                      { text: "",sortable: false, value: "editButton" } //Add edit button
                ]
        },
        equipmentData:{
          items:[]
        },
        equipmentPaging:{
          page:1,
          pageSize:20,
          totalItems:0
        },
        reservationDataHeaders:{
          items:[
                      {text: 'User',align: 'start',sortable: false, value: 'reserved_to_user'},
                      { text: 'Equipment',sortable: false, value: 'equipment_name' },
                      { text: 'Checkout Date',sortable: false, value: 'checkout_date_local' },
                      { text: 'Due Date',sortable: false, value: 'due_date_localfromnow' },
                      { text: 'Checkin User',sortable: false, value: 'checkin_user_id' },
                      { text: "",sortable: false, value: "editButton" } //Add edit button
                ]
        },
        reservationData:{
          items:[]
        },
        reservationPaging:{
          page:1,
          pageSize:20,
          totalItems:0
        },
        giveDataHeaders:{
          items:[
                      {text: 'User',align: 'start',sortable: false, value: 'user'},
                      { text: 'Equipment',sortable: false, value: 'description' },
                      { text: 'Checkout Date',sortable: false, value: 'category' },
                      { text: 'Due Date',sortable: false, value: 'quantity' },
                      //{ text: 'Last Updated',sortable: false, value: 'last_updated_localfromnow' },
                      { text: "",sortable: false, value: "editButton" } //Add edit button
                ]
        },
        giveData:{
          items:[]
        },
        givePaging:{
          page:1,
          pageSize:20,
          totalItems:0
        },
        equipmentService:null
      }
    },
    created(){
      this.equipmentService = new MitEquipmentApiService();
    },
    mounted() {
      this.categoryRefresh();
    },
    methods: {
      menuChange: function(index) {
        this.menuIndex = index;
        switch(index){
          case 0:
            this.categoryRefresh();
            break;
          case 1:
            this.equipmentRefresh();
            break;
          case 2:
            this.reservationRefresh();
            break;
        }
      },
      categoryRefresh: function() {
        console.log('refresh');
        this.equipmentService.getAllCategory()
          .then((categories) => {
            console.log('CATS', categories);
            this.categoryData.items = categories;
            this.categoryPaging.totalItems = categories.length;
          })
          .catch((error) => {
            console.log('An error occurred trying to get category', error);
          });
      },
      categoryCreate: function() {
        console.log('create');
      },
      categoryEdit: function(item) {
        console.log('edit',item);
      },
      equipmentRefresh: function() {
        console.log('refresh');
        this.equipmentService.getAllEquipment()
          .then((equipment) => {
            console.log('equipment', equipment);
            this.equipmentData.items = equipment;
            this.equipmentPaging.pageSize = equipment.length;
            this.equipmentPaging.totalItems = equipment.length;
          })
          .catch((error) => {
            console.log('An error occurred trying to get equipment list', error);
          });
      },
      equipmentCreate: function() {
        console.log('create');
      },
      equipmentEdit: function(item) {
        console.log('edit',item);
      },
      reservationRefresh: function() {
        console.log('refresh');
        this.equipmentService.getAllReservation()
          .then((reservation) => {
            console.log('reservation', JSON.stringify(reservation));
            this.reservationData.items = reservation;
            this.reservationPaging.pageSize = reservation.length;
            this.reservationPaging.totalItems = reservation.length;
          })
          .catch((error) => {
            console.log('An error occurred trying to get reservation list', error);
          });
      },
      reservationCreate: function() {
        console.log('create');
      },
      reservationEdit: function(item) {
        console.log('edit',item);
      },
      giveRefresh: function() {
        console.log('refresh');
        this.equipmentService.getAllGiveAways()
          .then((model) => {
            console.log('give aways', model);
            this.equipmentData.items = model;
            this.equipmentPaging.pageSize = model.length;
            this.equipmentPaging.totalItems = model.length;
          })
          .catch((error) => {
            console.log('An error occurred trying to get user list', error);
          });
      },
      giveCreate: function() {
        console.log('create');
      },
      giveEdit: function(item) {
        console.log('edit',item);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
